var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton, Tooltip } from '@chakra-ui/react';
const sizes = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl',
    '2xl',
];
export const TipButton = (props) => {
    const { icon, tipProps, size = 'md' } = props, iconButtonStyles = __rest(props, ["icon", "tipProps", "size"]);
    const fontSize = sizes[sizes.indexOf(size) - 1];
    return (_jsx(Tooltip, Object.assign({ hasArrow: true, placement: "top", fontSize: fontSize, px: "2", py: "1", borderRadius: size, label: props['aria-label'] }, tipProps, { children: _jsx(IconButton, Object.assign({ icon: icon, size: size }, iconButtonStyles)) })));
};
